import { Component, Input, EventEmitter, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { ResponseStateEnum } from '../discovery-process.enum';
import { ResponseState } from '../discovery-wizard-current-question/discovery-wizard-current-question.component';

@Component({
  selector: 'app-discovery-wizard-response',
  templateUrl: './discovery-wizard-response.component.html',
  styleUrls: ['./discovery-wizard-response.component.scss']
})

export class DiscoveryWizardResponseComponent  extends BaseComponent implements OnInit{

  @Input() responseState: ResponseStateEnum = ResponseStateEnum.Netural;
  @Input() isPositiveGreyedOut: boolean = false;
  @Input() isNegativeGreyedOut: boolean = false;

  @Input() responseText: string = "";
  @Input() responseId: string = "";
  @Output() positiveSelected =  new EventEmitter();
  @Output() negativeSelected =  new EventEmitter();
  responseBkColor :string = RESPONSE_DEFAULT_BK_COLOR;
  positiveBkColor : string = POSITIVE_ENABLED_BK_COLOR;
  positiveIconColor: string = POSITIVE_ENABLED_ICON_COLOR;
  negativeBKColor = NEGATIVE_ENABLED_BK_COLOR;
  negativeIconColor = NEGATIVE_ENABLED_ICON_COLOR;
  constructor() { 
    super()
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.calculateVisual();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!changes.reponseState || !changes.isPositiveGreyedOut || !changes.isNegativeGreyedOut){
      // This is done as Angular sucks.
      return;
    }

    if ((changes.reponseState.currentValue != changes.reponseState.previousValue && !changes.reponseState.firstChange) ||
        (changes.isPositiveGreyedOut.currentValue != changes.isPositiveGreyedOut.previousValue && !changes.isPositiveGreyedOut.firstChange) ||
        (changes.isNegativeGreyedOut.currentValue != changes.isNegativeGreyedOut.previousValue && !changes.isNegativeGreyedOut.firstChange)){
          this.calculateVisual();
      }
    }

  calculateVisual(): void{
    // setting to default value - if required this will cahnge
    this.responseBkColor = RESPONSE_DEFAULT_BK_COLOR;

    // positive button
    if (this.isPositiveGreyedOut){
      this.positiveBkColor = DISABLED_BK_COLOR;
      this.positiveIconColor = DISABLED_ICON_COLOR;
    }
    else if (this.responseState == ResponseStateEnum.Netural){
      this.positiveBkColor = POSITIVE_ENABLED_BK_COLOR;
      this.positiveIconColor = POSITIVE_ENABLED_ICON_COLOR;
    }
    else if (this.responseState == ResponseStateEnum.Positive){
      this.positiveBkColor = POSITIVE_SELECTED_BK_COLOR;
      this.positiveIconColor = SELECTED_ICON_COLOR;
      this.responseBkColor = RESPONSE_POSITVE_BK_COLOR;
      this.negativeBKColor = DISABLED_BK_COLOR;
      this.negativeIconColor = DISABLED_ICON_COLOR;
    }

    // negative button
    if (this.isNegativeGreyedOut){
      this.negativeBKColor = DISABLED_BK_COLOR;
      this.negativeIconColor = DISABLED_ICON_COLOR;
    }
    else if (this.responseState == ResponseStateEnum.Netural){
      this.negativeBKColor = NEGATIVE_ENABLED_BK_COLOR;
      this.negativeIconColor = NEGATIVE_ENABLED_ICON_COLOR;
    }
    else if (this.responseState == ResponseStateEnum.Negative){
      this.negativeBKColor = NEGATIVE_SELECTED_BK_COLOR;
      this.negativeIconColor = SELECTED_ICON_COLOR;
      this.responseBkColor = RESPONSE_NEGATIVE_BK_COLOR;
      this.positiveBkColor = DISABLED_BK_COLOR;
      this.positiveIconColor = DISABLED_ICON_COLOR;
    }
  }

  emitPositiveSelectedEvent(){
    console.log(`in dwr emitPositiveSelectedEvent`);
    this.positiveSelected.emit();
  }

  emitNegativeSelectedEvent(){
    console.log(`in dwr emitNegativeSelectedEvent`);
    this.negativeSelected.emit();
  }
}

const POSITIVE_SELECTED_BK_COLOR = "#4CAF50";
const NEGATIVE_SELECTED_BK_COLOR = "#F44336";
const POSITIVE_ENABLED_BK_COLOR = "#EDF7ED";
const POSITIVE_ENABLED_ICON_COLOR = "#4CAF50";
const NEGATIVE_ENABLED_BK_COLOR = "#FEECEB";
const NEGATIVE_ENABLED_ICON_COLOR = "#F44336";
const SELECTED_ICON_COLOR = "#FFFFFF";
const DISABLED_ICON_COLOR = "#878787";
const DISABLED_BK_COLOR = "#F3F3F3";
const RESPONSE_DEFAULT_BK_COLOR = "#E0E0E0";
const RESPONSE_POSITVE_BK_COLOR = "#C9E7CA";
const RESPONSE_NEGATIVE_BK_COLOR =  "#FCC6C2";